import { IAudit, IDoctor, IInstitution, IPatient } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { DocumentKind } from './audit/document-send-info.service';

/**
 * The document a report was opened for, and onto which the report page stores a dispatch.
 *
 * Only valid while the report page lives: it clears the value in `ionViewDidLeave`, so a route that
 * opens the page without publishing a document finds none rather than a foreign one.
 */
export interface IReportAuditInfo {
  patientId?: string;
  therapyId?: number;
  therapyTypeId?: number;
  woundLocation?: string;
  /** Covers institution documents as well, because `IInstitutionAudit` extends `IAudit`. */
  audit: IAudit;
  kind: DocumentKind;
}

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  public options$$ = new BehaviorSubject<{ mail: boolean; fax: boolean; mailSubject: string; mailBody: string }>(
    undefined
  );
  public patient$$ = new BehaviorSubject<IPatient>(undefined);
  public institution$$ = new BehaviorSubject<IInstitution>(undefined);
  public doctor$$ = new BehaviorSubject<IDoctor>(undefined);
  public data$$ = new BehaviorSubject(undefined);
  public reportData$$ = new BehaviorSubject(undefined);
  public type$$ = new BehaviorSubject<string>(undefined);
  public auditTherapyInfos$$ = new BehaviorSubject<IReportAuditInfo | undefined>(undefined);

  constructor() {}
}
